import { SplashController, SplashView } from '../SplashController';
import { TranslationTexts } from '../../../config/translate/TranslationTexts';
import { FontWeight } from '@nolimitcity/slot-launcher/bin/loader/font/FontStatics';
import { gsap, TweenLite } from 'gsap';
import { GameAssets } from '../../../GameAssets';
import { GameData } from '../../../server/data/GameData';
import { Translator } from '../../../../core/setting/Translator';
import { Helper } from '../../../../core/utils/Helper';
import { BitmapTextStyleOptions, TextStyleOptions } from '../../../../core/setting/text/IText';
import { OutroData } from './SplashViewFsOutro';
import { Beheaded } from '../../../Beheaded';
import { BeheadedPickAndClickPopUpView } from './BeheadedPickAndClickPopUpView';
import { SpinePlayer } from '../../../../core/displayobject/SpinePlayer';
import { SoundConfig } from '../../../config/sound/SoundConfig';

export class SplashViewSFSPickAndClick extends PIXI.Container implements SplashView {
    private _timeLine: gsap.core.Timeline;
    private _title: PIXI.Sprite;
    private _animation1: SpinePlayer;
    private _animation2: SpinePlayer;
    private _popUp1: BeheadedPickAndClickPopUpView;
    private _popUp2: BeheadedPickAndClickPopUpView;

    public static selected: number = 0;
    private internalTL: gsap.core.Timeline;

    private GameData: GameData;

    constructor(textStyle: TextStyleOptions) {
        super();
        this.init();
        this.visible = false;
    }

    public setData(data: GameData): void {
        this._popUp2.updateValue(data.raw.winCapProbabilityForTheRightSideChoice);
        this.GameData = data;
    }

    private init(): void {
        this._title = this.addChild(new PIXI.Sprite(Beheaded.assetLoader.getTextures('title')[0]));
        this._title.anchor.set(0.5, 0.5);
        this._title.position.set(0, -280);

        this._animation1 = new SpinePlayer('endAnimation', false);
        this._animation1.position.set(0, 0);
        this._animation1.scale.set(2, 2);

        this._animation2 = new SpinePlayer('endAnimation', false);
        this._animation2.position.set(0, 0);
        this._animation2.scale.set(2, 2);

        this._popUp1 = new BeheadedPickAndClickPopUpView(1);
        this._popUp2 = new BeheadedPickAndClickPopUpView(2);
        this._popUp1.position.set(-200, -150);
        this._popUp2.position.set(200, -150);

        this.addChild(this._animation1, this._animation2, this._popUp1, this._popUp2);
    }

    public enablePopup(selection: number, eventname: string = '') {
        const popSelected = [this._popUp1, this._popUp2][selection - 1];
        const popDeSelected = [this._popUp2, this._popUp1][selection - 1];

        this.internalTL = Helper.setTimeline(this.internalTL);

        this.internalTL.to(popSelected, { alpha: 1, duration: 0.15 }, 0);
        this.internalTL.to(popDeSelected, { alpha: 0, duration: 0.15 }, 0);

        if (eventname) {
            if (selection === 1 && SplashViewSFSPickAndClick.selected !== 1) {
                SplashViewSFSPickAndClick.selected = 1;
                this._animation1.play({ animation: 'butterflies_spawn' });
                Beheaded.soundPlayer.stopSound(SoundConfig.FS_OUTRO_LOOP_SKULL_HIGHLIGHT);
                Beheaded.soundPlayer.fadeSound(SoundConfig.FS_OUTRO_LOOP_SKULL, 1, 0, 100);
                Beheaded.soundPlayer.playSound(SoundConfig.FS_OUTRO_LOOP_BUTTERFLY_HIGHLIGHT);
                Beheaded.soundPlayer.fadeSound(SoundConfig.FS_OUTRO_LOOP_BUTTERFLY, 0, 1, 100);
            } else if (selection === 2 && SplashViewSFSPickAndClick.selected !== 2) {
                SplashViewSFSPickAndClick.selected = 2;
                this._animation2.play({ animation: 'lightning' });
                Beheaded.soundPlayer.stopSound(SoundConfig.FS_OUTRO_LOOP_BUTTERFLY_HIGHLIGHT);
                Beheaded.soundPlayer.fadeSound(SoundConfig.FS_OUTRO_LOOP_BUTTERFLY, 1, 0, 100);
                Beheaded.soundPlayer.playSound(SoundConfig.FS_OUTRO_LOOP_SKULL_HIGHLIGHT);
                Beheaded.soundPlayer.fadeSound(SoundConfig.FS_OUTRO_LOOP_SKULL, 0, 1, 100);
            }
            if (!Beheaded.splashWindow.button.alpha) Beheaded.splashWindow.enableButton();
        }
    }

    public removePopup() {
        this.internalTL = Helper.setTimeline(this.internalTL);
        this.internalTL.to([this._popUp1, this._popUp2], { alpha: 0, duration: 0.15 }, 0);
    }

    public play(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(
            this._timeLine,
            gsap.timeline({
                onStart: () => {
                    this.visible = true;
                },
            })
        );
        this._timeLine.add(Beheaded.backgroundCharacter.showSFSPick());
        this._timeLine.add(() => {
            if (!Beheaded.apiPlugin.isReplay) {
                Beheaded.backgroundCharacter.applyEvent({
                    hover: this.enablePopup.bind(this),
                    unHover: this.removePopup.bind(this),
                });
            }
        });

        this._timeLine.fromTo(this, { alpha: 0 }, { duration: 0.5, alpha: 1 }, 0);

        if (Beheaded.apiPlugin.isReplay) {
            Beheaded.backgroundCharacter.selectOptionForRestore(
                parseInt(this.GameData.raw.nextPlayerInteraction!.selectedIndex.toString())
            );
        }

        return this._timeLine;
    }

    public stop(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(
            this._timeLine,
            new gsap.core.Timeline({
                onComplete: () => {
                    this.visible = false;
                    this.removePopup();
                },
            })
        );
        
        Beheaded.backgroundCharacter.resetEvent();
        Beheaded.backgroundCharacter.clickOptionAnimation();

        this._timeLine.to(this, { duration: 0.35, alpha: 0 });
        return this._timeLine;
    }

    public onResize() {}
}
